

export const get = url => _fetch(url, "GET");

export const post = (url, data) => _fetch(url, "POST", data);

export const put = (url, data) => _fetch(url, "PUT", data);

var hostname = window.location.hostname;
let googleAnalyticID = 'UA-99728945-5';
var BASE_URL_APPOINTMENT = "http://appttest.sunnypoint.vn/appointment/api";
var AUTH = 'abc';

if (hostname == "staging.sunnypoint.jp") {
    BASE_URL_APPOINTMENT = "http://staging.sunnypoint.jp/appointment/api";
    googleAnalyticID = 'UA-99728945-5';
}
else if (hostname == "appointment-demo1.sunnypoint.jp"|| hostname == "https://appointment-demo1.sunnypoint.jp") {
    AUTH = "abc";
    BASE_URL_APPOINTMENT = "https://appointment-demo1.sunnypoint.jp/appointment/api";
    googleAnalyticID = 'UA-99728945-7';
}
else if (hostname == "appointment.sunnypoint.jp"|| hostname == "https://appointment.sunnypoint.jp") {
    AUTH = "CBHEwrDL71CJzsMo";
    BASE_URL_APPOINTMENT = "https://appointment.sunnypoint.jp/appointment/api";
    googleAnalyticID = 'UA-99728945-6';
}
else if (hostname == "apptdev.sunnypoint.vn"|| hostname == "https://apptdev.sunnypoint.vn") {
    BASE_URL_APPOINTMENT = "http://apptdev.sunnypoint.vn/appointment/api";
}

export const API_END_POINT = BASE_URL_APPOINTMENT;
export const gaId = googleAnalyticID;
//export const API_DETAIL_APPT = 'http://appttest.sunnypoint.vn/appointment/api/v1.5/merchant/getAppointmentInfoById?id='
const _fetch = (url, method, data = null) => {
    let options = {
        method,
        headers: {
            //'appointment-request-context': JSON.stringify(window.__appointment.requestContext || ''),
            'Content-Type': 'application/json',
            'auth':AUTH
        }
    };
    if (method === "POST") {
        options = {
            ...options,
            body: JSON.stringify(data),
            headers: {
                ...options.headers
            }
        };
    }
    return fetch(url, options)
        .then(_checkStatus);
};

const _checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};
